<!--
 * @Description: 原物料合同
 * @Autor: wangwangwang
 * @Date: 2021-01-28 09:46:13
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-03-19 13:55:41
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="tabtop">
          <div v-for="(item, index) in contractTypelist" :key="index" @click="choose(item.id)">
            <div :class="currenindex == item.id ? 'active' : 'text'">
              {{ item.value }}
            </div>
          </div>
        </div>
        <div class="header_right" @click="showCardNav = !showCardNav">
          <div class="title">搜索</div>
          <div>
            <transition name="from"></transition>
            <span v-show="!showCardNav">
              <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
            </span>
            <transition name="to"></transition>
            <span v-show="showCardNav">
              <i style="margin-right: 5px" class="el-icon-arrow-up"></i>
            </span>
          </div>
        </div>
        <div v-show="showCardNav" class="hr"></div>
        <el-collapse-transition>
          <div v-show="showCardNav">
            <div class="search">
              <span style="display: inline-block;margin-bottom: 10px;">
                <span style="margin-right: 12px">主合同单位</span>
                <el-input v-model="tableParam.supplierName" style="width: 240px" clearable placeholder="请输入"
                  @keyup.enter.native="gettableData()" />
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">站点名称</span>
                <el-input v-model="tableParam.stations" style="width: 240px" clearable placeholder="请输入"
                  @keyup.enter.native="gettableData()" />
              </span>
              <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="gettableData()">查
                询</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 12px"
                @click="searchDialog = true">高级搜索</el-button>
            </div>
          </div>
        </el-collapse-transition>
        <div class="hr"></div>
        <div class="card">
          <contract ref="contract" :currenindex="currenindex" @sumbit="init"></contract>
        </div>
      </el-main>
    </el-container>
    <el-dialog v-dialogDrag :visible.sync="searchDialog" width="580px" :close-on-click-modal="false"
      :before-close="search">
      <span slot="title" class="dialog-title">高级搜索</span>
      <div class="dialoginfo">
        <el-form ref="reftableParam" :inline="true" :model="tableParam" label-width="110px">
          <el-form-item>
            <span slot="label">供应商类别</span>
            <el-input v-model="tableParam.supplierType" tplaceholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">合作等级</span>
            <el-select v-model="tableParam.cooperationClassId" placeholder="请选择">
              <el-option v-for="item in cooperationIdlist" :key="item.id" :label="item.itemName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">招标编号</span>
            <el-input v-model="tableParam.callForBidsNumber" tplaceholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">状态</span>
            <el-select v-model="tableParam.enable" placeholder="请选择">
              <el-option :key="2" label="禁用" :value="0"></el-option>
              <el-option :key="1" label="启用" :value="1"></el-option>
              <el-option :key="3" label="全部" value=""></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">合同Id</span>
            <el-input :key="tableParam.code" v-model="tableParam.code" tplaceholder="请输入"
              clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two"
          @click="searchDialog = false, tableParam.supplierType = '', tableParam.cooperationClassId = '', tableParam.callForBidsNumber = ''">取
          消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="gettableData(), searchDialog = false">搜 索</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import breaDcrumb from "@/components/breadcrumb";
import contract from "../components/contract.vue"; //原物料
import { getDicsType } from "@/api/common.js";
export default {
  mixins: [mixin],
  components: {
    contract,
    breaDcrumb,
  },
  data() {
    return {
      currenindex: 1,
      searchDialog: false,
      supplierTypelist: [],
      cooperationIdlist: [],
      pagesType: 0,
      tableParam: {
        page: 1,
        pageSize: 10,
        enable: 1,
      },
      showCardNav: true,
      contractTypelist: [
        { value: "进行中", id: 1 },
        { value: "已过期", id: 2 },
        { value: "已总结算", id: 3 },
      ],
    };
  },
  created() {
    this.tableParam = { ...this.tableParam, contractTypeId: '1', contractStatus: 0, supplierName: "", stations: "", supplierType: '', cooperationClassId: '', callForBidsNumber: '', code: "", id: "", enable: 1 };
    if (this.$route.query.contractId) {
      this.tableParam.id = this.$route.query.contractId
    }
    getDicsType({ codes: "supplierType,Levelofcooperation" }).then((res) => {
      this.supplierTypelist = res.data.supplierType.items;
      this.cooperationIdlist = res.data.Levelofcooperation.items;
    });
  },
  mounted() {
    this.gettableData();
  },
  beforeDestroy() {
    this.$router.push({ query: {} })
  },
  methods: {
    init() {
      setTimeout(() => {
        this.tableParam = { ...this.tableParam, contractTypeId: '1', contractStatus: 0, supplierName: "", stations: "", supplierType: '', cooperationClassId: '', callForBidsNumber: '', code: "", id: "", enable: 1 };
        this.tableParam.contractStatus = this.currenindex - 1
        this.$refs.contract.initt(this.tableParam);
      }, 100);
    },
    gettableData() {
      setTimeout(() => {
        this.tableParam.page = 1;
        this.$refs.contract.srarch(this.tableParam);
      }, 100);
    },
    choose(num) {
      this.currenindex = num;
      this.$refs.contract.yiFenPeiRadio = ''
      this.tableParam.contractStatus = num - 1
      this.gettableData();
    },
    search() {
      this.searchDialog = false;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 320px;
}

.dialoginfo {
  padding: 0 20px 0 20px;
}

.dialoginfo-title {
  display: flex;
  align-items: center;
  height: 50px;

  >div {
    width: 4px;
    height: 20px;
    background: $bg_color;
  }

  >span {
    padding-left: 10px;
    font-size: 20px;
    color: $bg_color;
    font-weight: bold;
  }
}

.tabtop {
  width: 566px;
  display: flex;
  border: $bg_color 1px solid;
  border-radius: 4px;
  margin: 20px 20px 0 20px;

  >div {
    height: 40px;
    width: 190px;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    align-items: center;

    .text {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: $bg_color;
    }

    .active {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: #ffffff;
      background: $bg_color;
      border-radius: 4px;
    }

    .hr {
      height: 20px;
      width: 2px;
      background: $bg_color;
    }
  }
}</style>
